<template>
  <v-ons-page id="filters-menu">
    <v-ons-toolbar>
      <div class="center">Filter Products</div>
    </v-ons-toolbar>

    <div v-if="isSlider">
      <v-ons-list-header style="padding-bottom:10px">{{ slider.Label }}</v-ons-list-header>
      <!--<ons-range style="width: 100%;" value="25"></ons-range>-->
      <div id="range-slider"></div>
      <br>
      <div class="flex-row space-between" style="padding: 0 10px; color: #FFF;">
        <span class="filter-text">Min: {{min}}</span>
        <span class="filter-text">Max: {{max}}</span>
      </div>
      <br>
      <br>
    </div>

    <div v-for="select in selects">
      <v-ons-list-header>{{ select.Label }}</v-ons-list-header>
      <v-ons-list class="category-list">
        <v-ons-list-item
          v-for="(option, $index) in select.Options"
          :key="'option_'+$index"
          modifier="longdivider">
          <label class="left">
            <v-ons-checkbox
              :input-id="'radio'+option+$index"
              @click="updateSelected(option)"
              :value="option"
              v-model="type.selectedOptions">
            </v-ons-checkbox>
          </label>
          <label class="center" :for="'radio'+option+$index">
            {{ option }}
          </label>
        </v-ons-list-item>
      </v-ons-list>
    </div>
  </v-ons-page>
</template>

<script>
import Nouislider from 'nouislider'
import { appData } from '../data.js'

export default {
  name: 'filters-menu',
  props: {
    type: Object,
  },
  data () {
    return {
      slider: {},
      selects: [],
      max: '',
      min: '',
      isSlider: true
    }
  },
  methods: {
    goTo (url) {
      window.open(url, '_blank')
    },
    updateSelected(option) {
      // if(this.type.selectedOptions.includes(option)) {
      //   this.type.selectedOptions = this.type.selectedOptions.filter(st => st !== option);
      // } else {
      //   this.type.selectedOptions.push(option);
      // }
      appData.updateType(this.type);
    }
  },
  created() {
    //console.log(this.type);
    this.slider = this.type.Sliders[0];
    this.isSlider = !!this.slider;

    if(this.slider) {
      this.slider.High = parseFloat(this.slider.High);
      this.slider.Low = parseFloat(this.slider.Low);
      let difference = this.slider.High - this.slider.Low;
      let start = this.type.selectedMin ? this.type.selectedMin : this.slider.Low;
      let end = this.type.selectedMax ? this.type.selectedMax : this.slider.High;

      setTimeout(() => {
        let range = document.getElementById('range-slider');
        Nouislider.create(range, {
          range: {
            'min': this.slider.Low,
            'max': this.slider.High
          },
          start: [start, end],
          connect: true,
          step: parseFloat(this.slider.Increment)
        });

        range.noUiSlider.on('update', (values, handle) => {
          if(handle === 1) {
            if(this.slider.Increment.includes('.')) {
              this.max = values[1].substring(0, values[0].length - 1);
            } else {
              this.max = values[1].split('.')[0];
            }
            this.type.selectedMax = this.max;
            appData.updateType(this.type);
          }
          if(handle === 0) {
            if(this.slider.Increment.includes('.')) {
              this.min = values[0].substring(0, values[0].length - 1);
            } else {
              this.min = values[0].split('.')[0];
            }
            this.type.selectedMin = this.min;
            appData.updateType(this.type);
          }
        });
      },100);
    }

    this.selects = this.type.Selects;
  }
}
</script>

<style scoped>
.header {
  text-align: center;
  margin-bottom: 20px;
}

img {
  max-width: 150px;
}

ons-list-title {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FiltersMenu.vue